export enum AuthenticationSourceEnum {
    SocialIdpAuthentication = 'socialIdpAuthentication',
    LocalAccountAuthentication = 'localAccountAuthentication',
}
